import React from 'react';

import StarRateRoundedIcon from '@mui/icons-material/StarRateRounded';

import './CircularInfoBar.styles.css';

export interface CircularProgressBarProps {
  label: string;
  percentage: number;
  haveStar?: boolean;
}

export const CircularInfoBar = ({ label, percentage, haveStar }: CircularProgressBarProps) => {
  return (
    <div className={percentage === 100 ? 'cibBoxFill cibBox' : 'cibBox'}>
      <div className="label-cif">{haveStar ? label : `${label}%`}</div>
      {haveStar && <StarRateRoundedIcon className="label-cif-star" />}
    </div>
  );
};
